import type { ABTestGroup } from "../../types/ABTestGroup";

export const checkQueryParams = (): ABTestGroup => {
  const urlParams = new URLSearchParams(window.location.search);
  const abTestGroup = urlParams.get("ab_test_group");
  if (abTestGroup === "A_GROUP" || abTestGroup === "B_GROUP") {
    return abTestGroup;
  }
  return undefined;
};
